import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ApiCall, setFocus } from './utils';
import GoogleCaptcha from './GoogleCaptcha';

export const ModalForm = () => {
    const [enquireLoading, setEnquireLoading] = useState(false)
    const [showModal, setShowModal] = useState(false);
    const [captchaValue, setCaptchaValue] = useState(null);
    const [enquireNowDetails, setEnquireNowDetails] = useState({
        fullName: '',
        companyEmail: '',
        phNumber: '',
        companyName: '',
        websiteDevelopment: false,
        eCommerceSolutions: false,
        webApplicationDevelopment: false,
        mobileApplicationDevelopment: false,
        performanceMarketing: false,
        serachEngineOptimization: false,
        businessConsultancy: false,
        socialMediaOptimization: false,
    })

    const navigate = useNavigate()
    const handleEnquireChange = (e) => {
        const { name, value, type, checked } = e.target;
        setEnquireNowDetails((previous) => ({
            ...previous,
            [name]: type === 'checkbox' ? checked : value
        }))
    }
    const handleEnquireSubmit = async (e) => {

        let req = {
            ...enquireNowDetails,
            CompanyPhoneNo: enquireNowDetails.phNumber
        }
        const { fullName, phNumber, companyName, companyEmail, ...services } = enquireNowDetails;
        if (fullName.trim() === '') {
            toast.error('please enter full name')
            setFocus('txtFullName')
            return
        }
        if (phNumber.trim() === '') {
            toast.error('please enter phone number')
            setFocus('txtPhNumber')
            return
        }
        if (companyEmail.trim() === '') {
            toast.error('please enter company email')
            setFocus('txtCompanyEmail')
            return
        }
        if (companyName.trim() === '') {
            toast.error('please enter company name')
            setFocus('txtCompanyName')
            return
        }

        const isValid = Object.values(services).some(value => value)

        if (isValid) {
            if (!captchaValue) {
                alert('Please complete the reCAPTCHA');
                return;
            }
            try {
                setEnquireLoading(true)
                const res = await ApiCall("/api/Web/enquireNow", req)
                if (res.status === "SUCCESS") {
                    setEnquireLoading(false)
                    toast.success(res.message)
                    handleEnquireReset()
                    setShowModal(false)
                    navigate(`/thankyou?email=${enquireNowDetails.companyEmail}`)
                }
                else if (res.status === "ERROR") {
                    setEnquireLoading(false)
                    toast.error(res.message)
                }
            } catch (error) {
                toast.error('Some error occured, Please try again later!!');
                setEnquireLoading(false)
            } finally {
                setEnquireLoading(false)
            }
        } else {
            toast.error('please select at list one services')
        }
    }

    const handleEnquireReset = () => {
        setEnquireNowDetails((prev) => ({
            fullName: '',
            companyEmail: '',
            phNumber: '',
            companyName: '',
            websiteDevelopment: false,
            eCommerceSolutions: false,
            webApplicationDevelopment: false,
            mobileApplicationDevelopment: false,
            performanceMarketing: false,
            serachEngineOptimization: false,
            businessConsultancy: false,
            socialMediaOptimization: false,
        }))
    }
 
    useEffect(() => {
        setFocus('txtFullName')
    }, [])
    return (
        <>
            <div className="enquiry-now-btn">
                <h3><a className="text-white" onClick={() => setShowModal(!showModal)}>Enquire now</a></h3>
            </div>
            <div
                className={`modal fade ${showModal ? 'show d-block scale_anim' : ''}`}
                id="modalId"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="modalTitleId"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content mybg">
                        <div className="modal-header border-0">
                            <button
                                type="button"
                                className="btn-close"
                                onClick={() => setShowModal(false)}
                            ></button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <div className="form-group w-100 position-relative">
                                        <label className="form-label mb-0">FULL NAME <span className='text-danger'>*</span></label>
                                        <input
                                            id='txtFullName'
                                            type="text"
                                            name='fullName'
                                            className='form-control'
                                            value={enquireNowDetails.fullName}
                                            placeholder='Ex. Santosh'
                                            onChange={handleEnquireChange}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault()
                                                    setFocus("txtCompanyEmail")
                                                };
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <div className="form-group w-100 position-relative">
                                        <label className="form-label mb-0">COMPANY E-MAIL <span className='text-danger'>*</span></label>
                                        <input
                                            id='txtCompanyEmail'
                                            type="text"
                                            className='form-control'
                                            value={enquireNowDetails.companyEmail}
                                            placeholder='example@gmail.com'
                                            name="companyEmail"
                                            onChange={handleEnquireChange}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault()
                                                    setFocus("txtPhNumber")
                                                };
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <div className="form-group w-100 position-relative">
                                        <label className="form-label mb-0">PHONE NUMBER  <span className='text-danger'>*</span></label>
                                        <input
                                            type="number"
                                            className='form-control'
                                            value={enquireNowDetails.phNumber}
                                            placeholder='0987456123'
                                            name="phNumber"
                                            id='txtPhNumber'
                                            onChange={handleEnquireChange}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault()
                                                    setFocus("txtCompanyName")
                                                };
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <div className="form-group w-100 position-relative">
                                        <label className="form-label mb-0">COMPANY NAME <span className='text-danger'>*</span></label>
                                        <input
                                            type="text"
                                            className='form-control'
                                            value={enquireNowDetails.companyName}
                                            placeholder='Example company.Inc'
                                            name="companyName"
                                            id='txtCompanyName'
                                            onChange={handleEnquireChange}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault()
                                                    setFocus("txtWebsiteDevelopment")
                                                };
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <p>PLEASE SELECT THE SERVICES <span className='text-danger'>*</span></p>
                                    <div className="modal_services">
                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                name='websiteDevelopment'
                                                id="txtWebsiteDevelopment"
                                                onChange={handleEnquireChange}
                                                checked={enquireNowDetails.websiteDevelopment === true}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault()
                                                        setFocus("txtECommerceSolutions")
                                                    };
                                                }}
                                            />
                                            <label className="form-check-label" htmlFor="txtWebsiteDevelopment">Website Development</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                name='eCommerceSolutions'
                                                id="txtECommerceSolutions"
                                                onChange={handleEnquireChange}
                                                checked={enquireNowDetails.eCommerceSolutions === true}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault()
                                                        setFocus("txtWebApplicationDevelopment")
                                                    };
                                                }}
                                            />
                                            <label className="form-check-label" htmlFor="txtECommerceSolutions">E-Commerce Solutions</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                name='webApplicationDevelopment'
                                                id="txtWebApplicationDevelopment"
                                                onChange={handleEnquireChange}
                                                checked={enquireNowDetails.webApplicationDevelopment === true}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault()
                                                        setFocus("txtMobileApplicationDevelopment")
                                                    };
                                                }}
                                            />
                                            <label className="form-check-label" htmlFor="txtWebApplicationDevelopment">Web Application Development</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                name='mobileApplicationDevelopment'
                                                id="txtMobileApplicationDevelopment"
                                                onChange={handleEnquireChange}
                                                checked={enquireNowDetails.mobileApplicationDevelopment === true}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault()
                                                        setFocus("txtPerformanceMarketing")
                                                    };
                                                }}
                                            />
                                            <label className="form-check-label" htmlFor="txtMobileApplicationDevelopment">Mobile Application Development</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                name='performanceMarketing'
                                                id="txtPerformanceMarketing"
                                                onChange={handleEnquireChange}
                                                checked={enquireNowDetails.performanceMarketing === true}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault()
                                                        setFocus("txtSerachEngineOptimization")
                                                    };
                                                }}
                                            />
                                            <label className="form-check-label" htmlFor="txtPerformanceMarketing">Performance Marketing</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                name='serachEngineOptimization'
                                                id="txtSerachEngineOptimization"
                                                onChange={handleEnquireChange}
                                                checked={enquireNowDetails.serachEngineOptimization === true}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault()
                                                        setFocus("txtBusinessConsultancy")
                                                    };
                                                }}
                                            />
                                            <label className="form-check-label" htmlFor="txtSerachEngineOptimization">Serach Engine Optimization</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                name='businessConsultancy'
                                                id="txtBusinessConsultancy"
                                                onChange={handleEnquireChange}
                                                checked={enquireNowDetails.businessConsultancy === true}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault()
                                                        setFocus("txtSocialMediaOptimization")
                                                    };
                                                }}
                                            />
                                            <label className="form-check-label" htmlFor="txtBusinessConsultancy">Business Consultancy</label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                name='socialMediaOptimization'
                                                id="txtSocialMediaOptimization"
                                                onChange={handleEnquireChange}
                                                checked={enquireNowDetails.socialMediaOptimization === true}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {    
                                                        handleEnquireSubmit(e)
                                                    };
                                                }}
                                            />
                                            <label className="form-check-label" htmlFor="txtSocialMediaOptimization">Social Media Optimization</label>
                                        </div>

                                    </div>

                                    <GoogleCaptcha setCaptchaValue={setCaptchaValue}/>


                                    {
                                        enquireLoading ? <button className="text-decoration-none drona-btn btn w-100 my-4 py-0">Sending... </button> :

                                            <button onClick={(e) => handleEnquireSubmit(e)} className="text-decoration-none drona-btn btn w-100 my-4 py-0">Submit
                                                <svg
                                                    className="ms-2"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width={30}
                                                    height={30}
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                >
                                                    <style>
                                                        {
                                                            "\n  .send {\n\tanimation: send 2s cubic-bezier(1, -0.47, 0.01, 1.37) infinite both;\n}\n@keyframes send {\n  0% {\n    transform: translateY(0) translateX(0);\n  }\n  100% {\n    transform: translateY(-20px) translateX(20px);\n  }\n}\n\n"
                                                        }
                                                    </style>
                                                    <g className="send">
                                                        <path
                                                            stroke="#fff"
                                                            strokeLinecap="round"
                                                            strokeWidth={1.5}
                                                            d="M9.407 14.593l3.058-3.058"
                                                        />
                                                        <path
                                                            stroke="#fff"
                                                            strokeWidth={1.5}
                                                            d="M15.564 7.908a.432.432 0 01.528.528l-2.677 10.175a.432.432 0 01-.724.195L5.194 11.31a.432.432 0 01.195-.724l10.175-2.677z"
                                                        />
                                                    </g>
                                                </svg>
                                            </button>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`modal_ovarlay ${showModal ? 'd-block' : 'd-none'}`}></div>
        </>
    )
}
